











































































import _ from 'lodash'
import { DataTablePagination } from '@/types/_'
import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { maskCPFCNPJ, maskDate } from '@/utils/common'
import RegrasDeCalculoStore from '../../RegrasDeCalculo/Store/RegrasDeCalculoStore'
import ModalRemuneracaoSuporteEditarHospital from './ModalRemuneracaoSuporteEditarHospital.vue'
import ModalRemuneracaoSuporteHospital from './ModalRemuneracaoSuporteHospital.vue'

@Component({
  components: {
    ModalRemuneracaoSuporteHospital,
    ModalRemuneracaoSuporteEditarHospital,
  },
})
export default class ModalCadastroHospitaisGarantiaMinimaGlobal extends Vue {
  readyState: boolean = false
  loadHospitais: boolean = false
  loadAddHospital: boolean = false
  loadDeleteHospital: string = ''
  loadEditHospital: string = ''
  hospitalSearch: string = ''

  get getRegrasDeCalculoStore() { return getModule(RegrasDeCalculoStore, this.$store) }

  get getHospitais() { return this.getRegrasDeCalculoStore.hospitaisGarantiaMinimaGlobal }

  get paginacao() { return this.getRegrasDeCalculoStore.paginacaoCadastroHospitaisGarantiaMinimaGlobal }

  get loadingAddHospital() { return this.loadAddHospital }
  set loadingAddHospital(value: boolean) { this.loadAddHospital = value }

  get loadingDeleteHospital() { return this.loadDeleteHospital }
  set loadingDeleteHospital(value: string) { this.loadDeleteHospital = value }

  get loadingHospitais() { return this.loadHospitais }
  set loadingHospitais(value: boolean) { this.loadHospitais = value }

  get getHospitaisTableHeader() {
    return [
      { text: 'Hospital Nome', class: 'table-headers', align: 'left', value: 'hospitalNome' },
      { text: 'Criado Por', class: 'table-headers', align: 'left', value: 'createdByNome' },
      { text: 'Ações', class: 'table-headers', value: '', align: 'center', sortable: false },
    ]
  }

  maskCnpj(cnpj: string) {
    return maskCPFCNPJ(cnpj)
  }

  maskDate(date: string) {
    return maskDate(date)
  }

  async addHospital() {
    this.loadingAddHospital = true
    this.getRegrasDeCalculoStore.setModal({ name: 'regraGarantiaMinimaAddHospital', value: true })
    this.loadingAddHospital = false
  }

  async deleteHospital(id: any) {
    this.loadingDeleteHospital = id
    this.getRegrasDeCalculoStore.setIdForDeleteHospital(id)
    await this.getRegrasDeCalculoStore.deleteHospitalGarantiaMinimaGlobal()
    this.loadingDeleteHospital = ''
  }

  debouncedGetHospitais = _.debounce(param => this.getRegrasDeCalculoStore.getHospitaisGarantiaMinimaGlobal(param), 700)

  async updateTablePagination(pagination: DataTablePagination) {
    this.loadingHospitais = true
    this.debouncedGetHospitais(pagination)
    this.loadingHospitais = false
  }
}
